"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
var _reducers = require("../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../redux/sagas"));
var _reactRedux = require("react-redux");
var _PwhChartWrap = require("./PwhChartWrap");
var _HtgHxChartWrap = require("./HtgHxChartWrap");
var _reactErrorBoundary = require("react-error-boundary");
var _actions = require("../../redux/actions");
var _SelectAddress = require("./SelectAddress");
var _devices = require("../../redux/actions/devices");
var _material = require("@mui/material");
var _ChartParams = require("../../features/provider/ChartParams");
const _excluded = ["isDynamicHeight"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Component for displaying line group diagrams
 * @param siteId site id - require
 *
 * @return {JSX.Element}
 * @constructor
 */

const GroupedChartsContent = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    siteId
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(() => {
    return () => {
      dispatch((0, _actions.resetCharts)());
      dispatch((0, _devices.resetDevices)());
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SelectAddress.SelectAddress, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 6
  }, /*#__PURE__*/_react.default.createElement(_PwhChartWrap.PwhChartWrap, {
    siteId: siteId
  })), /*#__PURE__*/_react.default.createElement(_HtgHxChartWrap.HtgHxChartWrap, {
    siteId: siteId
  }));
});
const GroupedChartsInitial = props => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const firstEffect = (0, _react.useRef)(true);
  const coreDevices = (0, _reactRedux.useSelector)(store => {
    var _store$constants$pack;
    return ((_store$constants$pack = store[_paulCorePackage.constants.packageKey]) === null || _store$constants$pack === void 0 ? void 0 : _store$constants$pack.devices) || {};
  });
  (0, _react.useEffect)(() => {
    if (firstEffect.current && coreDevices !== null && coreDevices !== void 0 && coreDevices.hasData) {
      firstEffect.current = false;
      dispatch((0, _devices.setInitialDeviceData)({
        result: coreDevices
      }));
    }
  }, [dispatch, coreDevices]);
  (0, _react.useEffect)(() => {
    return () => {
      firstEffect.current = true;
      dispatch((0, _devices.resetDevices)());
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(GroupedChartsContent, props);
};
const GroupedCharts = _ref2 => {
  let {
      isDynamicHeight
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      charts: _reducers.charts,
      devices: _reducers.devices
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(_ChartParams.ChartParamsProvider, {
    isDynamicHeight: isDynamicHeight
  }, /*#__PURE__*/_react.default.createElement(GroupedChartsInitial, props));
};
var _default = exports.default = (0, _reactErrorBoundary.withErrorBoundary)(GroupedCharts, {
  FallbackComponent: () => /*#__PURE__*/_react.default.createElement(_paulCorePackage.ErrorBox, _paulCorePackage.constants.errorComponent[_paulCorePackage.constants.errorType.critical]),
  onError: (err, info) => console.error(err, info)
});